import TabProductAndComparation from "./tab-product-and-comparation";
import TabProductSoldGraph from "./tab-product-sold-graph";
import DateRangePickerComponent from "../../components/date-range-picker.component";
import ExportComponent from "../../components/export.component";
import {useDispatch, useSelector} from "react-redux";
import {
    setToolsCurrentPage,
    setToolsInitialState,
    setToolsModalVisibility,
    setToolsStartDateEndDate
} from "../../reducers/tools.reducer";
import TabProductSoldList from "./tab-product-sold-list";
import React, {useEffect} from "react";
import {dateRangeToday, downloadFileExport, formatDateToReadable} from "../../utils/general-variable";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import moment from "moment";

const ProductAnalyticsPage = () => {
    const dispatch = useDispatch()
    const {dateRange} = useSelector(state => state.toolsReducer)
    const {fetching: exportProductAnalytic, isLoading: loadingExport} = useFetch(API.EXPORT_PRODUCT_ANALYTIC)

    const getValueFromRangePickerSingle = (dateRange) => {
        dispatch(setToolsStartDateEndDate(dateRange))
        dispatch(setToolsCurrentPage(1))
    }

    const exportDataHandler = () => {
        const queryParams = {
            startDate: formatDateToReadable(dateRange[0], "YYYY-MM-DD"),
            endDate: formatDateToReadable(dateRange[1], "YYYY-MM-DD")
        }
        exportProductAnalytic(queryParams, '', {}, 'blob').then(res => {
            downloadFileExport(res, `Product-Analytic-Export-${moment().format()}.xlsx`)
        })
        dispatch(setToolsModalVisibility({export: false}))
    }

    useEffect(() => {
        dispatch(setToolsStartDateEndDate(dateRangeToday))
        return () => {
            dispatch(setToolsInitialState())
        }
    }, [])

    return (
        <div className={"col space-y-4 px-10 my-4"}>
            <div className={"row items-center justify-center space-x-4"}>
                <DateRangePickerComponent slug={'analytics'} onChange={getValueFromRangePickerSingle}/>
                <div>
                    <ExportComponent
                        wordingConfirmation={`Apakah anda yakin ingin melakukan export data analytics product ?`}
                        exportDataHandler={exportDataHandler}
                        isLoading={loadingExport}/>
                </div>
            </div>
            <TabProductAndComparation/>
            <TabProductSoldGraph/>
            <TabProductSoldList/>
        </div>
    )
}

export default ProductAnalyticsPage
